var map = {
	"./1/amazon.svg": "249e",
	"./1/discord.svg": "9322",
	"./1/email.svg": "f418",
	"./1/facebook.svg": "1c9f",
	"./1/instagram.svg": "a800",
	"./1/kwai.svg": "bf36",
	"./1/linkedin.svg": "e136",
	"./1/paypal.svg": "914e",
	"./1/pinterest.svg": "3418",
	"./1/reddit.svg": "2ec9",
	"./1/skype.svg": "c5cb",
	"./1/snapchat.svg": "6cfc",
	"./1/spotify.svg": "7915",
	"./1/telegram.svg": "06cb",
	"./1/threads.svg": "6cb4",
	"./1/tiktok.svg": "3ffa",
	"./1/tinder.svg": "b4ef",
	"./1/twitch.svg": "7dcf",
	"./1/web.svg": "1a8a",
	"./1/whatsapp.svg": "6dd0",
	"./1/x.svg": "d441",
	"./1/youtube.svg": "b43d",
	"./2/amazon.svg": "b085",
	"./2/discord.svg": "d415",
	"./2/email.svg": "ed13",
	"./2/facebook.svg": "ff32",
	"./2/instagram.svg": "ba6d",
	"./2/linkedin.svg": "64ac",
	"./2/paypal.svg": "6ec3",
	"./2/pinterest.svg": "2f64",
	"./2/skype.svg": "5e39",
	"./2/snapchat.svg": "ec78",
	"./2/spotify.svg": "5a02",
	"./2/telegram.svg": "a247",
	"./2/tiktok.svg": "8974",
	"./2/tinder.svg": "09b4",
	"./2/twitch.svg": "6537",
	"./2/web.svg": "fb3c",
	"./2/whatsapp.svg": "f3d2",
	"./2/x.svg": "3d1c",
	"./2/youtube.svg": "8613",
	"./3/amazon.svg": "e00d",
	"./3/discord.svg": "986d",
	"./3/email.svg": "f818",
	"./3/facebook.svg": "d6a1",
	"./3/instagram.svg": "cd8f",
	"./3/kwai.svg": "ae91",
	"./3/linkedin.svg": "0260",
	"./3/paypal.svg": "2f29",
	"./3/pinterest.svg": "7c56",
	"./3/reddit.svg": "e628",
	"./3/skype.svg": "9c6d",
	"./3/snapchat.svg": "7c09",
	"./3/spotify.svg": "789d",
	"./3/telegram.svg": "711a",
	"./3/threads.svg": "1ffd",
	"./3/tiktok.svg": "c9c2",
	"./3/tinder.svg": "834c",
	"./3/twitch.svg": "ee63",
	"./3/web.svg": "76a5",
	"./3/whatsapp.svg": "8fa6",
	"./3/x.svg": "1925",
	"./3/youtube.svg": "5af4",
	"./4/amazon.svg": "8464",
	"./4/discord.svg": "6809",
	"./4/email.svg": "0e28",
	"./4/facebook.svg": "7267",
	"./4/instagram.svg": "c01e",
	"./4/kwai.svg": "c931",
	"./4/linkedin.svg": "1f97",
	"./4/paypal.svg": "9415",
	"./4/pinterest.svg": "d428",
	"./4/reddit.svg": "704a",
	"./4/skype.svg": "2869",
	"./4/snapchat.svg": "2740",
	"./4/spotify.svg": "1ab9",
	"./4/telegram.svg": "a95d",
	"./4/threads.svg": "cdce",
	"./4/tiktok.svg": "a2fb",
	"./4/tinder.svg": "6f6b",
	"./4/twitch.svg": "589a",
	"./4/web.svg": "0c9c",
	"./4/whatsapp.svg": "af08",
	"./4/x.svg": "a092",
	"./4/youtube.svg": "c4a9",
	"./default/amazon.svg": "8306",
	"./default/discord.svg": "ec01",
	"./default/email.svg": "ba86",
	"./default/facebook.svg": "0bea",
	"./default/instagram.svg": "32fc",
	"./default/kwai.svg": "f3b3",
	"./default/linkedin.svg": "33b8",
	"./default/paypal.svg": "b3d7",
	"./default/pinterest.svg": "21d6",
	"./default/reddit.svg": "57c3",
	"./default/skype.svg": "382f",
	"./default/snapchat.svg": "1ec0",
	"./default/spotify.svg": "6d8f",
	"./default/telegram.svg": "44ea",
	"./default/threads.svg": "b420",
	"./default/tiktok.svg": "a35b",
	"./default/tinder.svg": "883a",
	"./default/twitch.svg": "c3e3",
	"./default/web.svg": "d9e6",
	"./default/whatsapp.svg": "1ffe",
	"./default/x.svg": "fcd3",
	"./default/youtube.svg": "346a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e11";